import { defineStore } from 'pinia'
import { getSavedState, saveState } from '@/utils/helper'
import * as Sentry from '@sentry/vue'

export const useFlowStore = defineStore('flow', {
  state: () => ({
    flow: getSavedState('donate.Flow') || null,
    done: false,
    message: getSavedState('donate.FlowAlert'),
    debugTimeoutId: null
  }),
  getters: {
    getFlow(state) {
      return state.flow
    },
    isFlowDone(state) {
      return state.done
    },
    getMessageAlert(state) {
      return state.message
    }
  },
  actions: {
    setFlowDone(val) {
      this.done = val

      if (this.done) {
        if (this.debugTimeoutId !== null) {
          Sentry.addBreadcrumb({
            category: 'pageLoad',
            message: 'setFlowDone(true)',
            level: 'debug'
          })

          clearTimeout(this.debugTimeoutId)
        }
        return
      }

      Sentry.addBreadcrumb({
        category: 'pageLoad',
        message: 'setFlowDone(false)',
        level: 'debug'
      })

      // If this `setFlowDone(false)` was called a second time when the current state
      // is still not done, then just leave the existing timer.
      if (this.debugTimeoutId !== null) {
        return
      }

      this.debugTimeoutId = setTimeout(() => {
        Sentry.captureMessage('Donation flow has been loading for 5 seconds')
        this.debugTimeoutId = setTimeout(() => {
          Sentry.captureMessage('Donation flow has been loading for 10 seconds')
          this.debugTimeoutId = setTimeout(() => {
            Sentry.captureMessage('Donation flow has been loading for 20 seconds')
          }, 10000)
        }, 5000)
      }, 5000)
    },
    updateFlow(newFlow) {
      this.flow = {
        ...this.flow,
        ...newFlow
      }
      saveState('donate.Flow', this.flow)
    },
    resetFlow() {
      let checkoutId = null
      if (this.flow?.checkoutId) {
        checkoutId = this.flow.checkoutId
      }
      this.flow = null

      if (checkoutId) {
        this.flow.checkoutId = checkoutId
      }
      saveState('donate.Flow', this.flow)
    },
    setMessageAlert(text) {
      this.message = text
      saveState('donate.FlowAlert', this.message)
    }
  }
})
